export default "__VITE_ASSET__782c7dc0__"